import React from "react";

const PresidentMessage = () => {
  return (
    <header className="section__container header__container" id="home">
      <div className="header__image__wrapper">
        <div className="image__accent__box"></div>
        <img
          src="./assets/About/CEO.jpg"
          alt="CEO"
          className="president__image"
        />
      </div>

      <div className="header__content__wrapper">
        {/* <h5 className="header__subtitle">The Vision</h5> */}
        <h1 className="header__title">CEO's Message</h1>

        <div className="message__card">
          <div className="scrollable-text">
            <p>
              The 21st century belongs to India, powered by its vast youth
              population. Education must go beyond academics to include values,
              purpose, and inner growth. As Dr. APJ Abdul Kalam said, “Be more
              dedicated to making solid achievements than in running after swift
              and synthetic happiness.” True progress lies in empowering youth
              with wisdom, not just information, and offering them guidance,
              support, and a space for reflection and self-discovery.
            </p>
            <p>
              Ethiccraft Club serves as that platform — helping youth reconnect
              with values, culture, and responsibility. In a world facing issues
              like addiction, confusion, and emotional instability, we aim to
              build a community of thoughtful, purpose-driven individuals. Our
              mission is to create a generation that lives with balance,
              compassion, and clarity — growing through life, not just going
              through it. Together, we can shape a better world, led by youth
              who live by values and lead by example.
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default PresidentMessage;
